// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import IconDropdownDown from "@tps/XDL/Icons//IconDropdownDown";
import { xBaseTheme } from "@tps/XDL/types";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            list: css`
                top: 36px;
                width: 100%;
            `,
            dropdownWrapper: css`
                && input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
            `,
        },
        iconProps: {
            src: IconDropdownDown,
            size: 13,
            color: `${color("common.ui5")}`,
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 13px;
                    width: auto;
                }
                svg {
                    width: 8px;
                    height: 13px;
                }
            `,
        },
        option: css`
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 26px;
            color: ${color("text.main")};
            background: ${color("common.ui1")};
            padding: 10px;

            &:hover {
                background: ${color("common.ui2")};
            }
        `,
    },
} as xBaseTheme["dynamicDropdown"];
